
export const decorateEnv = (env) => {
    env.build.buildDate = '20220805051455';
    env.build.buildDateEpoch = 1659676495285;
    env.build.buildRevision = '5f53fb3b229fb58eb581fc76808a54b31b2072d9';
    env.build.project = 'abbottadc';
    env.build.part = 'mgr';
    env.build.deployment = 'uat';
    env.build.viewport = 'pc';
    env.apiRoot = 'https://api-adccrm-s.abbott.com.cn';
    env.production = 'false';
    env.variables.mapApiKey = 'ee95e52bf08006f63fd29bcfbcf21df0';
};
